import React from 'react';
import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductCardV2Description = (props: PropsWithChildren) => {
  return (
    <BodyText sizeMatch={['16']} style={styles.description}>
      {props.children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  description: {
    marginBottom: theme.spacing['1'],
  },
});
